import cn from 'classnames';
import React from 'react';
import { useSwiper } from 'swiper/react';

import styles from './choose-kia-nav.module.scss';

export const SwiperNavButtons: React.FC<{
  range?: boolean;
}> = ({ range }) => {
  const swiper = useSwiper();

  return (
    <div className={styles.swiperNavBtns}>
      <button
        onClick={() => swiper.slidePrev()}
        className={cn(styles.buttons, styles.prev, {
          [styles.rangeprev as string]: range,
        })}
      ></button>
      <button
        onClick={() => swiper.slideNext()}
        className={cn(styles.buttons, styles.next, {
          [styles.rangenext as string]: range,
        })}
      ></button>
    </div>
  );
};
